import React, { useState, useEffect, useRef } from 'react';
import ReactDOM, { createPortal } from 'react-dom';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { motion, AnimatePresence } from 'framer-motion';
import { usePortal } from '../../hooks';

const drawerWrapVariants = {
  closed: {
    opacity: 0,
  },
  open: {
    opacity: 1,
  },
};

const setDrawerInnerVariants = (value) => {
  const pos = value == 'left' ? '-100%' : '100%';
  return drawerInnerVariants(pos)
  
}

const drawerInnerVariants = (x) => ({
  closed: {
    opacity: 0,
    x: x
  },
  open: {
    opacity: 1,
    x: 0,
    transition: { 
      duration: 0.6, 
      ease: [0.04, 0.62, 0.23, 0.98],
    },
  },
});

const renderCart = () => {
  return (
    <AnimatePresence>
      {showDrawer && (
        <motion.div
          initial={'closed'}
          custom={position}
          animate={'open'}
          exit={'closed'}
          variants={drawerWrapVariants}
          className={`Drawer ${className}`}
        >
          <motion.div
            initial={'closed'}
            animate={'open'}
            exit={'closed'}
            variants={drawerInnerVariants}
            className="Drawer__inner"
            ref={drawerInnerEl}
            style={position == 'left' ? { left: 0 } : { right: 0 }}
          >
            {children}
          </motion.div>
          <span className="backdrop" onClick={() => setShowDrawer(false)}></span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export const ReactDrawer = ({ parentNode, showDrawer, setShowDrawer, children, className, position }) => {
  const drawerInnerEl = useRef(null);
  const target = usePortal('modals-container');

  useEffect(() => {
    let target = drawerInnerEl.current;
    if (showDrawer) {
      if (className && className == 'Drawer--minicart'){
        target = drawerInnerEl.current.querySelector('.Loop--minicart');
      }
      disableBodyScroll(target);
    } else {
      if( drawerInnerEl.current){
        enableBodyScroll(target);  
      }
    }
    return () => {
      if (target){
        enableBodyScroll(target);
      }
    };
  }, [showDrawer]);

  return createPortal(
    <AnimatePresence>
      {showDrawer && (
        <motion.div
          initial={'closed'}
          custom={position}
          animate={'open'}
          exit={'closed'}
          variants={drawerWrapVariants}
          className={`Drawer ${className}`}
        >
          <motion.div
            initial={'closed'}
            animate={'open'}
            exit={'closed'}
            variants={setDrawerInnerVariants(position)}
            className="Drawer__inner"
            ref={drawerInnerEl}
            style={position == 'left' ? { left: 0 } : { right: 0 }}
          >
            {children}
          </motion.div>
          <span className="backdrop" onClick={() => setShowDrawer(false)}></span>
        </motion.div>
      )}
    </AnimatePresence>,
    target
  );
};
